<template>
    <div class="card skin-card shadow-sm mx-auto mb-5 mt-0" :class="cardClasses">
        <div class="card-header skin-card-header text-start d-flex align-items-center justify-content-between">
            <h3>{{ title }}</h3>
            <div v-if="showHelp" class="float-end">
                <help :title="helpTitle"
                      :text="helpText"
                      :color="getPanelHeadingHelpColor()" />
            </div>
        </div>
        <div class="card-body skin-card-body">
            <slot></slot>
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { Configuration } from "@/guiide/ts/configuration/configuration";
import { defineComponent } from "vue";
import Help from "./Help.vue";

export default defineComponent({
  name: "SubSection",
  components: {
    Help
  },
  props: {
    title: { type: String, required: true },
    showHelp: { type: Boolean, required: false, default: true },
    helpTitle: { type: String, required: false, default: "" },
    helpText: { type: Object as () => Array<string>, required: false },
    mdColCount: { type: String, required: false, default: "12" },
    mbSize: { type: String, required: false, default: "4" }
  },
  computed: {
    cardClasses: function(): string {
      return `col-lg-${this.mdColCount} my-${this.mbSize}`;
    }
  },
  methods: {
    getPanelHeadingHelpColor(): string {
      return Configuration.getCssVariableValue("--panel-heading-help-color");
    }
  }
});
</script>
